import axios from "axios";
import projectFieldDefs from "../../components/shared/constants/projectFieldDefs";
import { DOCUMENT_UPLOAD_RESULT, LENDER_ADD_PROJECT_INFO, REQUEST_ID_RESULT, REQUEST_TYPE_ID_RESULT, RESET_LENDER_REQUEST, RESET_LENDER_REQUEST_PROJECT_INFO, SET_ALL_DOC_TYPES_BY_ID, SET_DOC_TYPES_BY_FIELD, SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP, SET_PROJECT_FIELDS_MAP, SET_EDITING_CHANGES, SET_OPTIONAL_DOCUMENTS, SET_REQUEST_STATUSES, SET_REQUEST_SUBTYPE_LOOKUP, SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION, SET_REQUEST_SUBTYPES, SET_REQUEST_TYPE_NAME, SET_REQUIRED_DOCUMENTS, SET_REQUIRED_DOCUMENTS_WITH_COUNT, SET_PHASE_FIELDS_MAP, LENDER_ADD_PHASE_INFO, RESET_LENDER_REQUEST_PHASE_INFO, SET_REASON_CODES_TO_REQUEST_SUBTYPES } from "./ActionType";
import { buildReconciliationPayload, reconcileSubmissionOutcome } from "../../components/shared/services/SubmissionReconciliationService";
import { fetchStates, fetchStyles } from "./filterActions";
import phaseFieldDefs from "../../components/shared/constants/phaseFieldDefs";
import { REQUEST_TYPES } from "../../components/shared/constants/RequestTypes";

export const resetLenderRequest = () => ({
  type: RESET_LENDER_REQUEST,
});

export const resetProjectInfo = () => ({
  type: RESET_LENDER_REQUEST_PROJECT_INFO,
});

export const resetPhaseInfo = () => ({
  type: RESET_LENDER_REQUEST_PHASE_INFO,
});

export const projectInfoResult = projectInfo => ({
  type: LENDER_ADD_PROJECT_INFO,
  payload: projectInfo
});

export const phaseInfoResult = phaseInfo => ({
  type: LENDER_ADD_PHASE_INFO,
  payload: phaseInfo
});

export const storeDocTypeLookupByFieldName = requiredDocTypesByFieldName => ({
  type: SET_DOC_TYPES_BY_FIELD,
  payload: requiredDocTypesByFieldName
});

export const documentUploadResult = result => ({
  type: DOCUMENT_UPLOAD_RESULT,
  payload: result
});

export const storeRequestTypeName = requestTypeName => ({
  type: SET_REQUEST_TYPE_NAME,
  payload: requestTypeName
});

export const requestIdResult = requestId => ({
  type: REQUEST_ID_RESULT,
  payload: requestId
});

export const requestTypeIdResult = requestTypeId => ({
  type: REQUEST_TYPE_ID_RESULT,
  payload: requestTypeId
});

export const requestSubTypesResult = requestSubTypeModels => ({
  type: SET_REQUEST_SUBTYPES,
  payload: requestSubTypeModels
});

export const requestSubTypeLookupResult = lookup => ({
  type: SET_REQUEST_SUBTYPE_LOOKUP,
  payload: lookup
});

export const requiredDocTypesResult = docTypes => ({
  type: SET_REQUIRED_DOCUMENTS,
  payload: docTypes
});

export const optionalDocTypesResult = docTypes => ({
  type: SET_OPTIONAL_DOCUMENTS,
  payload: docTypes
});

export const requiredDocTypesWithCountResult = docTypesWithCount => ({
  type: SET_REQUIRED_DOCUMENTS_WITH_COUNT,
  payload: docTypesWithCount
});

export const allDocTypesResult = allDocTypesById => ({
  type: SET_ALL_DOC_TYPES_BY_ID,
  payload: allDocTypesById
});

export const storeFieldChanges = changes => ({
  type: SET_EDITING_CHANGES,
  payload: changes
});

// TODO: select project or phase field defs during initLenderRequest based on request type
export const editableProjectFieldsResult = projectFieldsMap => ({
  type: SET_PROJECT_FIELDS_MAP,
  payload: projectFieldsMap
});

// TODO: select project or phase field defs during initLenderRequest based on request type
export const editablePhaseFieldsResult = phaseFieldsMap => ({
  type: SET_PHASE_FIELDS_MAP,
  payload: phaseFieldsMap
});

export const requestStatusesResult = requestStatuses => ({
  type: SET_REQUEST_STATUSES,
  payload: requestStatuses
});

export const reasonCodeToRequestSubTypeResult = reasonCodeToRequestSubTypeLookup => ({
  type: SET_REASON_CODES_TO_REQUEST_SUBTYPES,
  payload: reasonCodeToRequestSubTypeLookup
});

// note: this name is a mouthful, but it's the only way to describe what this is for.
// the API might return multiple requestSubTypeDocIds for a single document type, so we 
// need to track them all for later when we save the attachments.
export const documentToRequestSubTypeJunctionResult = documentToRequestSubTypeJunction => ({
  type: SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP,
  payload: documentToRequestSubTypeJunction
});
export const requestSubTypeToDocumentJunctionResult = requestSubTypeToDocumentJunction => ({
  type: SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION,
  payload: requestSubTypeToDocumentJunction
});

export function initLenderRequest(requestTypeName) {
  return async function(dispatch) {
    // console.groupCollapsed('initLenderRequest - before api call');
    // console.log('requestTypeName', requestTypeName);
    // console.groupEnd();

    dispatch(storeRequestTypeName(requestTypeName));

    const response = await axios.get(
      global.REACT_APP_API_ENDPOINT + `/lender/request/requestTypeByName/`,
      { params: { requestTypeName } }
    );

    if (response.status == 200 && response.data && response.data !== "Request type not found.") {
      const requestTypeDTO = response.data;
      const { requestTypeId, requestSubTypeDTOS } = requestTypeDTO;

      // workarounds for bad data on backend
      const correctedRequestSubTypeDTOS = requestSubTypeDTOS.map(dto => ({
        ...dto,
        requestSubTypeName: dto.requestSubTypeName === "Update  altProjectName" ? "Update altProjectName"
          : dto.requestSubTypeName === "Update type" ? "Update newProjectType"
          : dto.requestSubTypeName === "Update unitType" ? "Update unitsType"
          : dto.requestSubTypeName
      }));

      const allDocTypesById = new Map();
      
      // note: This var name is a mouthful, but it's the only way to describe what this is for.
      // the API might return multiple requestSubTypeDocIds for a single document type, so we 
      // need to track them all and store the mapping for later when we save the attachments.
      // For each documentRankingId, we store a Set of requestSubTypeDocIds. We will need to
      // retrieve all of them later when saving attachments.
      const documentToRequestSubTypeJunction = new Map();
      const requestSubTypeToDocumentJunction = new Map();

      const requestSubTypesModel = correctedRequestSubTypeDTOS
        .map(dto => {
          const docTypes = dto.requestSubTypeDocsDTOS.map(docDto => {
            // temporary workaround until backend is fixed
            const rank = docDto.requestDocumentRankingDTO.documentName !== "Other"
              ? docDto.requestDocumentRankingDTO.rank
              : 999999;

            const required = docDto.required;
            const active = docDto.active;

            allDocTypesById.set(docDto.documentRankingId, {
              documentRankingId: docDto.documentRankingId,
              name: docDto.requestDocumentRankingDTO.documentName,
              required,
              active,
              rank
            });
            
            if (!documentToRequestSubTypeJunction.has(docDto.documentRankingId)) {
              documentToRequestSubTypeJunction.set(docDto.documentRankingId, []);
            }

            documentToRequestSubTypeJunction
              .get(docDto.documentRankingId)
              .push({
                requestSubTypeId: docDto.requestSubTypeId,
                requestSubTypeDocId: docDto.requestSubTypeDocId
              });

            if (!requestSubTypeToDocumentJunction.has(dto.requestSubTypeId)) {
              requestSubTypeToDocumentJunction.set(dto.requestSubTypeId, []);
            }

            requestSubTypeToDocumentJunction
              .get(dto.requestSubTypeId)
              .push({
                documentRankingId: docDto.documentRankingId,
                requestSubTypeDocId: docDto.requestSubTypeDocId
              });

            // todo: refactor so that requestSubTypeDocId is mapped separately and we only
            // keep one copy of each doctype
            return {
              documentRankingId: docDto.documentRankingId,
              name: docDto.requestDocumentRankingDTO.documentName,
              required,
              active,
              rank,
              // requestSubTypeDocId: docDto.requestSubTypeDocId
            };
          }).filter(Boolean);
            // .sort((a, b) => a.rank - b.rank);

          return {
            requestSubTypeId: dto.requestSubTypeId,
            requestSubTypeName: dto.requestSubTypeName,
            subRequestReasonCodeId: dto.subRequestReasonCodeId || 0,
            numberOfRequiredDocs: (dto.numberOfRequiredDocs >= 1) ? dto.numberOfRequiredDocs : 1,
            docTypes
          };
        });

      const requestSubTypeLookup = requestSubTypesModel.reduce((lookup, item) => ({
        ...lookup,
        [item.requestSubTypeId]: item,
        [item.requestSubTypeName]: item,
      }), {});

      // build a map from reason code to requestSubTypeId
      const reasonCodeToRequestSubTypeLookup = new Map();
      requestSubTypesModel.forEach(rst => {
        if (rst.subRequestReasonCodeId) {
          reasonCodeToRequestSubTypeLookup.set(rst.subRequestReasonCodeId, rst.requestSubTypeId);
        }
      });

      const requiredDocsByFieldName = {};
      const requiredDocsByRequestSubType = {};
      
      requestSubTypesModel.forEach(rst => {
        const requiredDocTypes = rst.docTypes.filter(dt => dt.required);
        requiredDocsByRequestSubType[rst.requestSubTypeId] = requiredDocTypes;
        requiredDocsByRequestSubType[rst.requestSubTypeName] = requiredDocTypes;

        if (requestTypeName === REQUEST_TYPES.LENDER_EDIT_PROJECT) {
          const fieldName = rst.requestSubTypeName.replace("Update ", "");

          if (!fieldName) {
            console.error(`initLenderRequest - unable to determine fieldName for request subtype ${rst.requestSubTypeName}`, rst);
          } else {
            requiredDocsByFieldName[fieldName] = requiredDocTypes;
          }
        }
      });

      console.groupCollapsed('initLenderRequest - inside requestTypeByName call');
      console.log('requestTypeName', requestTypeName);
      console.log('requestTypeId', requestTypeId);
      console.log('requestTypeDTO', requestTypeDTO);
      console.log('requestSubTypeDTOS', requestSubTypeDTOS);
      console.log('correctedRequestSubTypeDTOS', correctedRequestSubTypeDTOS);
      console.log('requestSubTypesModel', requestSubTypesModel);
      console.log('requestSubTypeLookup', requestSubTypeLookup);
      console.log('reasonCodeToRequestSubTypeLookup', reasonCodeToRequestSubTypeLookup);
      console.log('requiredDocsByFieldName', requiredDocsByFieldName);
      console.log('requiredDocsByRequestSubType', requiredDocsByRequestSubType);
      console.log('allDocTypesById', [...allDocTypesById.entries()]);
      console.log('documentToRequestSubTypeJunction', documentToRequestSubTypeJunction);
      console.groupEnd();
      
      if (requestTypeName === REQUEST_TYPES.LENDER_EDIT_PROJECT) {
        dispatch(storeDocTypeLookupByFieldName(requiredDocsByFieldName));
      }
      
      dispatch(requestTypeIdResult(requestTypeId));
      dispatch(requestSubTypeLookupResult(requestSubTypeLookup));
      dispatch(reasonCodeToRequestSubTypeResult(reasonCodeToRequestSubTypeLookup));
      // dispatch(allRequestSubTypesResult(requestSubTypesModel));
      dispatch(documentToRequestSubTypeJunctionResult(documentToRequestSubTypeJunction));  
      dispatch(allDocTypesResult(allDocTypesById));

      // Let callers (optionally) reuse the list of subtype ids without recomputing.
      return requestSubTypesModel.map(rst => rst.requestSubTypeId);
    }

    return [];
  };
}

export function selectFieldChanges(editingChanges) {
  return function(dispatch) {
    const requestSubTypeNames = editingChanges?.map(change => `Update ${change.fieldName}`);

    // console.groupCollapsed('selectFieldChanges');
    // console.log('editingChanges', editingChanges);
    // console.log('requestSubTypeNames', requestSubTypeNames);
    // console.groupEnd();

    dispatch(storeFieldChanges(editingChanges));
    return dispatch(selectRequestSubTypesByName(requestSubTypeNames));
  };
}

export function selectRequestSubTypesByName(requestSubTypeNames) {
  return function(dispatch, getState) {
    const { lenderRequestReducer } = getState();
    const requestSubTypeLookup = lenderRequestReducer.requestSubTypeLookup;
    
    // console.groupCollapsed('selectRequestSubTypesByName');
    // console.log('requestSubTypeNames', requestSubTypeNames);
    // console.log('requestSubTypeLookup', requestSubTypeLookup);
    
    const requestSubTypeIds = requestSubTypeNames.map(name => requestSubTypeLookup?.[name]?.requestSubTypeId).filter(Boolean);
    
    // console.log('requestSubTypeIds', requestSubTypeIds);    
    // console.groupEnd();
    
    if (requestSubTypeIds.length !== requestSubTypeNames.length) {
      console.error(`setRequestSubTypesByName - not all requestSubTypeNames found: [${requestSubTypeNames}] :: [${requestSubTypeIds}]`);
    }

    dispatch(selectRequestSubTypesById(requestSubTypeIds));

    return requestSubTypeIds;
  };
}

export function selectRequestSubTypesById(requestSubTypeIds) {
  return async function(dispatch, getState) {
    const { lenderRequestReducer } = getState();
    const requestSubTypeLookup = lenderRequestReducer.requestSubTypeLookup;

    // console.groupCollapsed('selectRequestSubTypesById - start');
    // console.log('requestSubTypeIds', requestSubTypeIds);
    // console.log('requestSubTypeLookup', requestSubTypeLookup);
    // console.groupEnd();

    const requestSubTypeModels = requestSubTypeIds.map(id => requestSubTypeLookup?.[id]).filter(Boolean);

    // console.log('requestSubTypeModels', requestSubTypeModels);    
    // console.groupEnd();
    
    if (requestSubTypeModels.length !== requestSubTypeIds.length) {
      console.error(`selectRequestSubTypesById - requestSubTypeModels does not match requestSubTypeIds`, requestSubTypeIds, requestSubTypeModels);
    }

    const requiredNested = [];
    const requiredNestedWithCount = [];
    const allDocTypesById = new Map();
    const allRequiredDocTypeIds = new Set();
    
    // // note: This var name is a mouthful, but it's the only way to describe what this is for.
    // // the API might return multiple requestSubTypeDocIds for a single document type, so we 
    // // need to track them all and store the mapping for later when we save the attachments.
    // // For each documentRankingId, we store a Set of requestSubTypeDocIds. We will need to
    // // retrieve all of them later when saving attachments.
    // const documentToRequestSubTypeJunction = new Map();

    requestSubTypeModels.forEach(requestSubTypeModel => {
      if (!requestSubTypeModel.docTypes?.length) {
        console.warn(`Empty required doctype list for requestSubType "${requestSubTypeModel.requestSubTypeName}" in selectRequestSubTypesById`, requestSubTypeModel);
      } else {
        requestSubTypeModel.docTypes.forEach(dt => {
          allDocTypesById.set(dt.documentRankingId, dt)

          // if (!documentToRequestSubTypeJunction.has(dt.documentRankingId)) {
          //   documentToRequestSubTypeJunction.set(dt.documentRankingId, []);
          // }

          // documentToRequestSubTypeJunction.get(dt.documentRankingId).push(dt.requestSubTypeDocId);
        });

        // only add each list to requiredNested if an equivalent list doesn't already exist
        // filter by both required AND active - inactive docs should not be displayed
        const requiredDocsGroup = requestSubTypeModel.docTypes.filter(dt => dt.required && dt.active);
        const requiredSet = new Set(requiredDocsGroup.map(dt => dt.documentRankingId));
        allRequiredDocTypeIds.add(...requiredSet);

        // Determine the count for this group, capped at group size
        const rawCount = requestSubTypeModel.numberOfRequiredDocs || 1;
        if (rawCount > requiredDocsGroup.length) {
          console.warn(`numberOfRequiredDocs (${rawCount}) exceeds available doc types (${requiredDocsGroup.length}) for "${requestSubTypeModel.requestSubTypeName}". Capping at ${requiredDocsGroup.length}.`);
        }
        const count = Math.min(rawCount, requiredDocsGroup.length);

        // Check for existing duplicate group in requiredNested
        const existingIndex = requiredNested.findIndex(existingGroup => 
            existingGroup.length === requiredDocsGroup.length && 
            existingGroup.every(dt => requiredSet.has(dt.documentRankingId)));
        
        if (existingIndex === -1) {
          requiredNested.push(requiredDocsGroup);
          requiredNestedWithCount.push({ count, docs: requiredDocsGroup });
        } else {
          // Duplicate group — use Math.max() for count (strictest wins)
          const existingEntry = requiredNestedWithCount[existingIndex];
          existingEntry.count = Math.max(existingEntry.count, count);
        }
      }
    });

    // filter optional docs - exclude required docs AND inactive docs
    const optionalFlat = [...allDocTypesById.values()].filter(docType => !docType.required && docType.active);

    // // TODO: Remove this when backend is fixed to always include "Other" as an optional doctype
    // if (!optionalFlat.find(d => d.name === "Other")) {
    //   optionalFlat.push({documentRankingId: -1, name: "Other", required: false, rank: 999999});
    // }

    console.groupCollapsed('selectRequestSubTypesById - end');
    console.log('requestSubTypeIds', requestSubTypeIds);
    console.log('requestSubTypeModels', requestSubTypeModels);
    console.log('requestSubTypeLookup', requestSubTypeLookup);
    console.log('allDocTypesById', [...allDocTypesById.entries()]);
    console.log('requiredNested', requiredNested);
    console.log('requiredNestedWithCount', requiredNestedWithCount);
    console.log('allRequiredDocTypeIds', allRequiredDocTypeIds);
    console.log('optionalFlat', optionalFlat);
    // console.log('documentToRequestSubTypeJunction', [...documentToRequestSubTypeJunction.entries()].map(([key, value]) => key + ' => ' + value));
    console.groupEnd();

    dispatch(requestSubTypesResult(requestSubTypeModels));
    dispatch(requiredDocTypesResult(requiredNested));    
    dispatch(requiredDocTypesWithCountResult(requiredNestedWithCount));
    dispatch(optionalDocTypesResult([optionalFlat])); // todo: refactor so optional is not a nested array
    // dispatch(documentToRequestSubTypeJunctionResult(documentToRequestSubTypeJunction));  
  };
}

export function submitAddProjectRequest(projectInfo) {
  return async function(dispatch, getState) {
    const passData = JSON.parse(sessionStorage.getItem("passData"));
    const { lenderRequestReducer } = getState();

    console.groupCollapsed('submitAddProjectRequest');
    console.log("projectInfo", projectInfo);
    console.log("lenderRequestReducer", lenderRequestReducer);
    console.log("passData", passData);
    console.groupEnd();

    const requestSubTypeModels = lenderRequestReducer.requestSubTypes;
    const requestTypeId = lenderRequestReducer.requestTypeId;
    const requestSubTypeLookup = lenderRequestReducer.requestSubTypeLookup;
    
    if (!requestTypeId) {
      throw `Missing requestTypeId in submitAddProjectRequest`;
    }

    if (!requestSubTypeLookup) {
      throw "Missing requestSubTypeLookup in submitAddProjectRequest";
    }
    
    if (!requestSubTypeModels?.length) {
      throw `Missing requestSubTypes in submitAddProjectRequest`;
    }
    
    const requestSubTypeModel = requestSubTypeModels[0];

    if (!requestSubTypeModel?.requestSubTypeId) {
      console.error("Empty requestSubTypeId in submitAddProjectRequest", requestSubTypeModel);
      throw `Empty requestSubTypeId in submitAddProjectRequest`;
    }

    const requestSubTypeId = requestSubTypeModel.requestSubTypeId;
    const bypassDuplicateProjectId = projectInfo.bypassDuplicateProjectId || projectInfo.duplicateProjectId;
    
    const formData = {
        // ...projectInfo,
        projectName: projectInfo.phaseName,
        // cpmId: projectInfo.cpmId,
        altProjectName: projectInfo.alternativeName,
        alternativeName: projectInfo.alternativeName,
        projectStyle: projectInfo.style,
        style: projectInfo.style,
        conveyedUnits: projectInfo.conveyedUnits,
        newProjectType: projectInfo.type,
        type: projectInfo.type,
        styleComments: projectInfo.styleComments,
        unitCount: projectInfo.units,
        units: projectInfo.units,
        street: projectInfo.streetAddress,
        streetAddress: projectInfo.streetAddress,
        city: projectInfo.city,
        state: projectInfo.state,
        coopInd: projectInfo.coopInd,
        manfdHousngInd: projectInfo.manfdHousngInd,
        unitsType: projectInfo.unitsType,
        zip5: projectInfo.zip5,
        zipPlus4: projectInfo.zip,
        zip: projectInfo.zip,
        hoaName: projectInfo.HOAname,
        HOAname: projectInfo.HOAname,
        hoaTaxId: projectInfo.HOAtaxid,
        HOAtaxid: projectInfo.HOAtaxid,
        masterAssociationName: projectInfo.masterAssociationName || projectInfo.MAname,
        MAname: projectInfo.MAname || projectInfo.masterAssociationName,
        comments: projectInfo.comments,
        isProjectComplete: projectInfo.isProjectComplete,
        isProjectSubjectToAddPhase: projectInfo.isProjectSubjectToAddPhase,
        isProjectHOATurnoverOwner: projectInfo.isProjectHOATurnoverOwner,
        hasDeveloperOwnedUnits: projectInfo.hasDeveloperOwnedUnits,
        developerOwnedUnits: projectInfo.developerOwnedUnits,
        userName: passData.firstName + " " + passData.lastName,
        createdBy: passData.user,
        requestTypeId,
        requestSubTypeId,
        hasNewPhaseRequest: !!projectInfo.phases?.length,
        // Preserve bypass flag and normalize project id from either input key.
        bypassDuplicate: projectInfo.bypassDuplicate,
        duplicateProjectId: bypassDuplicateProjectId
      }; 

    const phasesDto = (projectInfo.phases || []).map(phase => ({
      phaseName: phase.phaseName,
      street: phase.street,
      city: projectInfo.city,
      state: projectInfo.state,
      zip5: projectInfo.zip5,
      zipPlus4: projectInfo.zip,
      isReviewInManualMode: true,
      phaseUnitCount: phase.unitsPerPhase,
      phaseType: phase.phaseType,
      bldgNbr: phase.buildingNumber,
      unitNbr: phase.unitNumber,
      createdBy: passData.user,
      requestTypeId,
      // dtExpiryFmReviewStatus: "2025-10-31T23:59:59",
    }));

    const lenderId =
      sessionStorage.getItem("lenderId") ||
      passData.sellerServicerCoNo || "12346";

    if (!lenderId) {
      throw "Empty lenderId in submitAddProjectRequest";
    }

    const response = await axios
      .post(
        global.REACT_APP_API_ENDPOINT + `/lender/request/lenderSaveProjectProfile/${lenderId}`,
        { 
          projectProfile: formData, 
          condoPhaseStagingRequests: phasesDto,
        }
      ).catch(error => {
        throw Error(error);
      });

    if (response?.status == 200 && response.data) {
      const { masterTrackerId: requestId, projectId } = response.data;
      
      await dispatch(projectInfoResult({ ...projectInfo, projectId }));
      dispatch(requestIdResult(requestId));
     
      return {requestId, projectId};
    } else if (!response?.data) {
      console.error("Empty response when creating request", response)
      throw "Empty response when creating request";
    } else if (response.data.cpDetails) {
      console.error("Duplicate project error", response)
      throw "Duplicate project error";
    } else if (response.message) {
      if (response.message == 'Internal server error') {
        window.location.href = "/error-page";
        return;
      }
    }    

    console.error("Error creating lender request", response)
    throw "Error creating lender request.";
  };
}

export function submitAddProjectRequestWithDocs(projectInfo, tempId, tempDocuments) {
  return async function(dispatch, getState) {
    const passData = JSON.parse(sessionStorage.getItem("passData"));
    const { lenderRequestReducer } = getState();

    const requestSubTypeModels = lenderRequestReducer.requestSubTypes;
    const requestTypeId = lenderRequestReducer.requestTypeId;
    const requestSubTypeLookup = lenderRequestReducer.requestSubTypeLookup;

    if (!requestTypeId) throw 'Missing requestTypeId in submitAddProjectRequestWithDocs';
    if (!requestSubTypeLookup) throw 'Missing requestSubTypeLookup in submitAddProjectRequestWithDocs';
    if (!requestSubTypeModels?.length) throw 'Missing requestSubTypes in submitAddProjectRequestWithDocs';
    if (!tempId) throw 'Missing tempId in submitAddProjectRequestWithDocs';

    const requestSubTypeModel = requestSubTypeModels[0];
    if (!requestSubTypeModel?.requestSubTypeId) throw 'Empty requestSubTypeId in submitAddProjectRequestWithDocs';

    const requestSubTypeId = requestSubTypeModel.requestSubTypeId;
    const bypassDuplicateProjectId = projectInfo.bypassDuplicateProjectId || projectInfo.duplicateProjectId;

    const formData = {
      projectName: projectInfo.phaseName,
      altProjectName: projectInfo.alternativeName,
      alternativeName: projectInfo.alternativeName,
      projectStyle: projectInfo.style,
      style: projectInfo.style,
      conveyedUnits: projectInfo.conveyedUnits,
      newProjectType: projectInfo.type,
      type: projectInfo.type,
      styleComments: projectInfo.styleComments,
      unitCount: projectInfo.units,
      units: projectInfo.units,
      street: projectInfo.streetAddress,
      streetAddress: projectInfo.streetAddress,
      city: projectInfo.city,
      state: projectInfo.state,
      coopInd: projectInfo.coopInd,
      manfdHousngInd: projectInfo.manfdHousngInd,
      unitsType: projectInfo.unitsType,
      zip5: projectInfo.zip5,
      zipPlus4: projectInfo.zip,
      zip: projectInfo.zip,
      hoaName: projectInfo.HOAname,
      HOAname: projectInfo.HOAname,
      hoaTaxId: projectInfo.HOAtaxid,
      HOAtaxid: projectInfo.HOAtaxid,
      masterAssociationName: projectInfo.masterAssociationName || projectInfo.MAname,
      MAname: projectInfo.MAname || projectInfo.masterAssociationName,
      comments: projectInfo.comments,
      isProjectComplete: projectInfo.isProjectComplete,
      isProjectSubjectToAddPhase: projectInfo.isProjectSubjectToAddPhase,
      isProjectHOATurnoverOwner: projectInfo.isProjectHOATurnoverOwner,
      hasDeveloperOwnedUnits: projectInfo.hasDeveloperOwnedUnits,
      developerOwnedUnits: projectInfo.developerOwnedUnits,
      userName: passData.firstName + " " + passData.lastName,
      createdBy: passData.user,
      requestTypeId,
      requestSubTypeId,
      hasNewPhaseRequest: !!projectInfo.phases?.length,
      // Carried through only when the user bypassed an exact-match duplicate
      // warning in DuplicateProjectModal; undefined/omitted otherwise.
      bypassDuplicate: projectInfo.bypassDuplicate,
      duplicateProjectId: bypassDuplicateProjectId
    };

    const phasesDto = (projectInfo.phases || []).map(phase => ({
      phaseName: phase.phaseName,
      street: phase.street,
      city: projectInfo.city,
      state: projectInfo.state,
      zip5: projectInfo.zip5,
      zipPlus4: projectInfo.zip,
      isReviewInManualMode: true,
      phaseUnitCount: phase.unitsPerPhase,
      phaseType: phase.phaseType,
      bldgNbr: phase.buildingNumber,
      unitNbr: phase.unitNumber,
      createdBy: passData.user,
      requestTypeId,
    }));

    const lenderId =
      sessionStorage.getItem("lenderId") ||
      passData.sellerServicerCoNo || "12346";

    if (!lenderId) throw "Empty lenderId in submitAddProjectRequestWithDocs";

    // R1/R2: Attempt submit; branch on 5xx for reconciliation, pass through 4xx as-is.
    let response;
    try {
      response = await axios.post(
        global.REACT_APP_API_ENDPOINT + `/lender/request/lenderSaveProjectProfileWithDocs/${lenderId}`,
        {
          projectProfile: formData,
          condoPhaseStagingRequests: phasesDto,
          tempId,
          documents: tempDocuments
        }
      );
    } catch (submitError) {
      const submitStatus = submitError?.response?.status;
      // R1: 5xx or no-response (network/gateway timeout) → trigger reconciliation
      if (!submitStatus || submitStatus >= 500) {
        const payload = buildReconciliationPayload(lenderId, tempId, projectInfo);
        const reconciliationOutcome = await reconcileSubmissionOutcome(payload);

        if (reconciliationOutcome?.resolvedProjectId) {
          await dispatch(projectInfoResult({
            ...projectInfo,
            projectId: reconciliationOutcome.resolvedProjectId,
          }));
        }

        if (reconciliationOutcome?.resolvedRequestId) {
          dispatch(requestIdResult(reconciliationOutcome.resolvedRequestId));
        }

        return { reconciliationOutcome };
      }
      // R2: 4xx → preserve existing client/validation error behavior (re-throw original to keep error.response)
      throw submitError;
    }

    if (response?.status >= 200 && response?.status < 300 && response.data) {
      if (response.data.cpDetails) {
        throw "Duplicate project error";
      }

      const { masterTrackerId: requestId, projectId, message, partialFailure, movedFiles } = response.data;

      if (partialFailure) {
        console.debug('[SFMLCM016-718] partialFailure=true from ProjectResponseDTO', { message, movedFiles });
      }

      await dispatch(projectInfoResult({ ...projectInfo, projectId }));
      dispatch(requestIdResult(requestId));

      return { requestId, projectId, message, partialFailure, movedFiles };
    } else if (!response?.data) {
      throw "Empty response when creating request with docs";
    }

    throw "Error creating lender request with docs.";
  };
}

export function submitEditProjectRequest(projectId, phaseId) {
  return async function(dispatch, getState) {
    const { lenderRequestReducer } = getState();

    // console.groupCollapsed('submitLenderEditRequest - start');
    // console.log('projectInfo', projectInfo);
    // console.log('lenderRequestReducer', lenderRequestReducer);
    // console.groupEnd();

    const requestTypeId = lenderRequestReducer.requestTypeId;
    const editingChanges = lenderRequestReducer.editingChanges;
    const requestSubTypeId = phaseId 
      ? lenderRequestReducer.requestSubTypeLookup?.["Update Phase"]?.requestSubTypeId
      : 134; // temporary workaround until backend supports multiple subtypes

    if (!requestTypeId) {
      throw "Missing requestTypeId in submitLenderEditRequest";
    }

    if (!editingChanges) {
      throw "Missing editingChanges in submitLenderEditRequest";
    }

    if (!requestSubTypeId) {
      throw "Missing requestSubTypeId in submitLenderEditRequest";
    }

    if (!editingChanges.length) {
      return; // nothing to do
    }

    const passData = JSON.parse(sessionStorage.getItem("passData"));
    const lenderId =
      sessionStorage.getItem("lenderId") ||
      passData.sellerServicerCoNo || "12346"

    // Read summaryAnalysis (notes) from the stored projectInfo or phaseInfo
    const notes = phaseId
      ? lenderRequestReducer.phaseInfo?.summaryAnalysis || ""
      : lenderRequestReducer.projectInfo?.summaryAnalysis || "";

    const payload = {
      masterTracker: {
        requestTypeId, 
        requestSubTypeId, // todo: remove this when backend is fixed and deployed
        projectId,
        phaseId,
        lenderId,
        createdBy: passData.user,
        updatedBy: passData.user
      },
      // todo: remove activityTracker when backend is fixed and deployed
      activityTracker: {
        requestStatusId: 5,
        notes: notes || "Initial assignment"
      },
      stagingList: editingChanges.map(item => ({
        dataAttributeName: item.fieldName,
        oldValue: item.oldValue,
        newValue: item.newValue
      }))
    };

    console.groupCollapsed('submitLenderEditRequest - before api call');
    console.log('projectId', projectId);
    console.log('payload', payload);
    console.groupEnd();

    const response = await axios.post(
      global.REACT_APP_API_ENDPOINT + `/lender/request/saveLenderEditRequest`,
      payload
    );

    if (response.status == 200 && response.data && +response.data > 0) {
      const requestId = +response.data;
      // dispatch(projectInfoResult(projectInfo));
      dispatch(requestIdResult(requestId));
      // incrementCounter?.();
      return {requestId, projectId, phaseId};
    } else {
      console.error("Error in /saveLenderEditRequest", response);
      throw response;
    }
  };
}

export function submitAddPhaseRequest(phases, comment) {
  return async function(dispatch, getState) {
    const { lenderRequestReducer } = getState();

    const requestTypeId = lenderRequestReducer.requestTypeId;
    const projectInfo = lenderRequestReducer.projectInfo;

    if (!requestTypeId) {
      console.error("No requestTypeId available in submitAddPhaseRequest", lenderRequestReducer);
      throw "No requestTypeId available in submitAddPhaseRequest";
    }

    if (!projectInfo) {
      console.error("No projectInfo available in submitAddPhaseRequest", lenderRequestReducer);
      throw "No projectInfo available in submitAddPhaseRequest";
    }
    const passData = JSON.parse(sessionStorage.getItem("passData"));
    
    const lenderId =
      sessionStorage.getItem("lenderId") ||
      passData.sellerServicerCoNo || "12346";

    const response = await axios.post(
      global.REACT_APP_API_ENDPOINT + `/lender/request/savePhaseStaging/`,
      phases.map(phase => ({
        projectId: projectInfo.projectId,
        street: phase.street,
        city: projectInfo.city,
        state: projectInfo.state,
        zip5: projectInfo.zip5,
        zipPlus4: projectInfo.zipplus4 ?? projectInfo.zip,
        phaseUnitCount: +phase.unitsPerPhase || undefined,
        phaseName: phase.phaseName,
        bldgNbr: phase.buildingNumber,
        unitNbr: phase.unitNumber,
        createdBy: passData.user,
        createdDate: new Date().toISOString(),
        requestTypeId,
        comments: comment,
        phaseType: phase.phaseType,
        lenderId
      }))
    );

    if (!response?.data || response.status !== 200 || response.data.message == "Internal server error") {
      console.error("RequestNewPhasePage: Error saving new phase data", response);
      throw "RequestNewPhasePage: Error saving new phase data";
    }
    
    const requestId = response.data;  
    dispatch(requestIdResult(requestId));
    return requestId 
  };
}

// export function submitEditPhaseRequest(phaseInfo) {
//   return async function(dispatch, getState) {
//     const {requestSubTypeLookup, requestTypeId} = getState().lenderRequestReducer;

//     if (!requestSubTypeLookup) {
//       throw "Missing requestSubTypeLookup in submitEditPhaseRequest";
//     }

//     const passData = JSON.parse(sessionStorage.getItem("passData"));

//     const payload = [{
//       // isReviewInManualMode: ,
//       // dtExpiryFmReviewStatus: phaseInfo.fnmaReviewStatusDtExpiry,
//       requestTypeId,
//       createdBy: passData.user,
//       createdDate: new Date().toISOString(),
//       projectId: phaseInfo.projectId,
//       phaseName: phaseInfo.phaseName,
//       phaseType: phaseInfo.phaseType,
//       street: phaseInfo.street,
//       city: phaseInfo.city,
//       state: phaseInfo.state,
//       zip5: phaseInfo.zip5,
//       zipplus4: phaseInfo.zipplus4 ?? phaseInfo.zip,
//       phaseUnitCount: phaseInfo.unitCount,
//       bldgNbr: phaseInfo.bldgNbr,
//       unitNbr: phaseInfo.unitNbr,
//       fmReviewStatus: phaseInfo.fnmaReviewStatus,
//     }];


//     const requestId = await axios
//       .post(
//         global.REACT_APP_API_ENDPOINT + `/lender/request/savePhaseStaging`,
//         payload
//       )
//       .then(response => {
//         console.log("/savePhaseStaging response", {payload, response});
//         if (response.status == 200 && response.data) {      
//           return response.data;
//         } else {
//           console.error('/savePhaseStaging error', {payload, response});
//           throw response;
//         }
//       })
//       .catch(error => {
//         console.error('/savePhaseStaging error', {payload, error});
//         throw Error(error);
//       })
//     return requestId;
//   };
// }

export function saveAttachments(requestId, uploadedDocs, incrementCounter) {
    return function(dispatch, getState) {
      const state = getState();
      const requestSubTypeModels = state.lenderRequestReducer.requestSubTypes;

      if (!requestSubTypeModels?.length) {
        throw "Empty or missing requestSubTypes, " + requestSubTypeModels;
      }

      const documentToRequestSubTypeJunction = state.lenderRequestReducer.documentToRequestSubTypeJunction;

      if (!documentToRequestSubTypeJunction?.size) {
        throw "Empty or missing documentToRequestSubTypeJunction, " + documentToRequestSubTypeJunction;
      }

      const docAssociations = [];

      const activeRequestSubTypeIds = new Set(requestSubTypeModels.map(rst => rst.requestSubTypeId));

      for (const docObj of uploadedDocs) {
        const requestSubTypeDocIds = 
          documentToRequestSubTypeJunction.get(docObj.documentRankingId)
            .filter(idPair => activeRequestSubTypeIds.has(idPair.requestSubTypeId))
            .map(idPair => idPair.requestSubTypeDocId);

        if (!requestSubTypeDocIds?.length) {
          console.error(`No requestSubTypeDocIds found for documentRankingId ${docObj.documentRankingId} in saveAttachments`, {docObj, documentToRequestSubTypeJunction});
          throw `No requestSubTypeDocIds found for documentRankingId ${docObj.documentRankingId} in saveAttachments`;
        }

        requestSubTypeDocIds.forEach(requestSubTypeDocId => {
          docAssociations.push({
            requestSubTypeDocId,
            docMapId: docObj.docMapId,
            notes: docObj.note || null
          });
        });
      }

      const passData = JSON.parse(sessionStorage.getItem("passData"));
      const payload = {
        requestId,
        requestMasterTrackerId: requestId,
        createdBy: passData.user,
        docAssociations
      };

      console.groupCollapsed('saveAttachments - before api call');
      console.log('requestId', requestId);
      console.log('uploadedDocs', uploadedDocs);
      console.log('requestSubTypeModels', requestSubTypeModels);
      console.log('documentToRequestSubTypeJunction', documentToRequestSubTypeJunction);
      console.log('docAssociations', docAssociations);
      console.log('payload', payload);
      console.groupEnd();


      return axios
        .post(
          global.REACT_APP_API_ENDPOINT + `/lender/request/saveDocsByTrackerId`,
          payload
        )
        .then(response => {
          console.log("saveAttachments - /saveDocsByTrackerId response", response);
          if (response.status == 200 && response.data && response.data !== "Can't save the Documents successfully.") {  
            dispatch(documentUploadResult(response.data));  
            incrementCounter?.();     
            return response.data;
          } else {
            console.error({payload, response})
            throw response;
          }
        })
        .catch(error => {
          throw Error(error);
        });
    }
}

export function fetchRequestStatuses() {
  return async function(dispatch) {
    const response = await axios.get(`${global.REACT_APP_API_ENDPOINT}/lender/request/requestStatuses`);

    if (response.status === 200) {
      const statuses = response.data.map(dto => ({
        projectRequestStatusId: dto.projectRequestStatusId,
        statusName: dto.statusName,
        internalStatus: dto.internalStatus,
        externalStatus: dto.externalStatus,
        statusDefinition: dto.statusDefinition,
      }));

      // console.log("Fetched request statuses:", statuses);

      dispatch(requestStatusesResult(statuses));
    } else {
      throw new Error("Failed to fetch request statuses");
    }
  }
}

export function buildRequestFieldDefs() {
  return async function(dispatch, getState) {
    let state = getState();

    // console.log("buildRequestFieldDefs before", JSON.parse(JSON.stringify(state)));

    if (state.lenderRequestReducer.projectFieldsMap?.size) {
      // console.log("projectFieldsMap already built");
      return;
    }

    if (!state.dialogueReducer.states?.length) {
      // console.log("dispatching fetchStates")
      await dispatch(fetchStates());
      state = getState();
    }

    if (!state.styleReducer.styles?.length) {
      // console.log("dispatching fetchStyles")
      await dispatch(fetchStyles());
      state = getState();
    }

    // console.log("buildRequestFieldDefs after", JSON.parse(JSON.stringify(state)));
    
    const stateList = state.dialogueReducer.states;
    const projectStyles = state.styleReducer.styles;

    // TODO: select project or phase field defs during initLenderRequest based on request type

    const projectFieldsMap = new Map();    
    projectFieldDefs.forEach(field => {
      if (field.fieldName === "state") {
        field.options = stateList;
      } else if (field.fieldName === "projectStyle") {
        field.options = projectStyles;
      }
      
      projectFieldsMap.set(field.fieldName, field);
    });    
    dispatch(editableProjectFieldsResult(projectFieldsMap));
    
    const phaseFieldsMap = new Map();
    phaseFieldDefs.forEach(field => {
      phaseFieldsMap.set(field.fieldName, field);
    });
    dispatch(editablePhaseFieldsResult(phaseFieldsMap));

    // console.log("Built projectFieldsMap:", projectFieldsMap);
    // console.log("Built phaseFieldsMap:", phaseFieldsMap);
  }
}